import './StickyCta.css';

export default function StickyCta() {
  return (
    <div className="sticky-cta" id="stickyCta">
      <i className="fas fa-play-circle"></i>
      <span>Explore Live Properties Feed</span>
    </div>
  );
}